import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Graphs from "../Graphs";
import henceforthApi from "../../utils/henceforthApi";
import { Button } from "../ui/button";

const periodTabs = [
  { label: "Daily", value: "DAILY" },
  { label: "Weekly", value: "WEEKLY" },
  { label: "Monthly", value: "MONTHLY" },
];

export default () => {
  const [priceHistory, setPriceHistory] = useState({
    data: [],
  });
  const location = useLocation();
  const navigate = useNavigate();
  const searchParam = new URLSearchParams(location.search);

  const currentType = searchParam.get("type") || "DAILY";

  const changeGraphType = (type: string) => {
    const newParam = new URLSearchParams(location.search);
    if (type && type !== "DAILY") {
      newParam.set("type", type);
    } else {
      newParam.delete("type");
    }
    navigate({ search: newParam.toString() });
  };

  const initialPriceHistory = async () => {
    try {
      const res = await henceforthApi.Dashboard.getTradingPriceById(
        searchParam.get("type")
      );
      setPriceHistory({
        ...priceHistory,
        ...res.data,
      });
    } catch { }
  };

  useEffect(() => {
    initialPriceHistory();
  }, [searchParam.get("type")]);

  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 p-5 sm:p-6 shadow-2xs">
      {/* Header Row */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 pb-4">
        <div>
          <div className="flex items-center gap-2">
            <h2 className="text-base sm:text-lg font-bold text-slate-900 leading-tight">
              Time vs Sales
            </h2>
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold bg-slate-100 text-slate-600">
              Intraday 24h
            </span>
          </div>
          <p className="text-xs text-slate-400 mt-0.5">
            Total Bookings & Revenue trend over time
          </p>
        </div>

        {/* Period Selector Tabs */}
        <div className="flex items-center gap-1 self-start sm:self-auto bg-slate-100/70 p-1 rounded-xl border border-slate-200/60">
          {periodTabs.map((tab) => {
            const isActive = currentType === tab.value;
            return (
              <Button
                variant={isActive ? "default" : "secondary"}
                key={tab.value}
                type="button"
                onClick={() => changeGraphType(tab.value)}
                className={`px-3 py-1 text-xs font-semibold rounded-lg transition-all cursor-pointer ${isActive
                  ? "bg-[#0f3d2e] text-white shadow-2xs"
                  : "text-slate-600 hover:text-slate-900"
                  }`}
              >
                {tab.label}
              </Button>
            );
          })}
        </div>
      </div>

      {/* Chart */}
      <div className="w-full">
        <Graphs.LineChart {...priceHistory} />
      </div>
    </div>
  );
};